module.exports = __webpack_public_path__ + "img/planner.46b78025.jpg";